<template>
  <section class="relative px-4 py-16 sm:py-24 overflow-hidden" style="background-color: #000;">

    <img
      :src="trofeuparis"
      alt=""
      class="absolute inset-0 w-full h-full object-cover object-center"
      style="opacity: 0.25; z-index: 0;"
    />
    <div class="absolute inset-0" style="background: linear-gradient(to bottom, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.7) 100%); z-index: 1;"></div>

    <div class="relative mx-auto w-full max-w-5xl" style="z-index: 2;">
      <h2 class="mb-16 text-center text-3xl font-bold text-white md:text-4xl tracking-wide uppercase">
        Prêmios & Reconhecimentos
      </h2>

      <div class="relative rounded-3xl overflow-hidden flex flex-col lg:flex-row"
        style="border: 1px solid rgba(245,158,11,0.3); background: rgba(0,0,0,0.5); backdrop-filter: blur(6px);">

        <div class="w-full lg:w-2/5 flex flex-col items-center justify-center px-8 py-10 gap-4"
          style="border-right: 1px solid rgba(245,158,11,0.15);">
          <div class="relative">
            <div class="absolute inset-0 rounded-xl blur-2xl opacity-60"
              style="background: radial-gradient(circle, #f59e0b, transparent); transform: scale(1.2);"></div>
            <img
              :src="destaqueParis"
              alt="Troféu Destaque 2025"
              class="relative w-52 h-auto rounded-xl shadow-2xl"
              style="border: 2px solid rgba(245,158,11,0.5);"
            />
          </div>
          <span class="text-amber-400 text-xs font-bold tracking-widest uppercase text-center">
            Troféu Destaque 2025
          </span>
        </div>

        <div class="w-full lg:w-3/5 flex flex-col justify-center px-8 py-10 lg:py-12">
          <span class="text-amber-400 text-xs font-bold tracking-widest uppercase block mb-3">
            Internacional · Paris, 2025
          </span>
          <h3 class="text-2xl font-bold text-white mb-4 leading-tight">
            Troféu Destaque Internacional 2025 — Paris
          </h3>
          <p class="text-gray-300 text-base mb-6 leading-relaxed">
            A OVER X foi reconhecida internacionalmente com o Troféu Destaque 2025, premiada em Paris como uma das startups de maior destaque, confiabilidade e inovação no cenário global.
          </p>
          <ul class="space-y-3 text-gray-200 text-sm font-medium">
            <li class="flex items-start gap-3">
              <span class="text-amber-400 text-lg leading-none">★</span>
              Reconhecimento oficial em cerimônia internacional em Paris
            </li>
            <li class="flex items-start gap-3">
              <span class="text-amber-400 text-lg leading-none">★</span>
              Destaque entre as startups mais inovadoras de 2025
            </li>
            <li class="flex items-start gap-3">
              <span class="text-amber-400 text-lg leading-none">★</span>
              Comprometimento comprovado com qualidade e excelência
            </li>
            <li class="flex items-start gap-3">
              <span class="text-amber-400 text-lg leading-none">★</span>
              Verificada e premiada por líderes do ecossistema global
            </li>
          </ul>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import destaqueParis from "../../../public/images/trofeu.jpeg";
import trofeuparis from "../../../public/images/trofeu-paris.png";

export default {
  name: "SelosCard",
  data() {
    return {
      destaqueParis,
      trofeuparis,
    };
  },
};
</script>